import { $fontSize, $paddingX, $paddingY, phoneSize } from '@/assets/styles/mediaSize';
import { FC } from 'react';
import { styled } from 'styled-components';
import RobotSortOneItem, { IKnowledge } from './RobotSortOneItem';
import { flexPos } from '@/assets/styles/mixin';
import { EFaqKnows, useFaq } from '@/service/useChat';
import { IMessage } from '@/store/messageStore';
import useUserStore from '@/store/userStore';
import { Message } from '@arco-design/web-react';
import useAppStore from '@/store/appStore';
import { useLang } from '@/locales/useLang';

interface IRobotSortOneProps {
  msgBody: string;
  messageItem: IMessage;
}

interface IRobotMsg {
  knowledgeBaseTitle: string;
  knowledgeBaseList: IKnowledge[];
}

const RobotSortOneWrap = styled.div`
  background-color: #fff;
  ${$paddingX('24rem', '12rem')}
  ${$paddingY('24rem', '12rem')}
  ${$fontSize('28rem', '14rem')}

  border-radius: 0 24rem 24rem 24rem;
  @media (min-width: ${phoneSize}) {
    border-radius: 0 12rem 12rem 12rem;
  }

  max-width: 540rem;
  word-break: break-all;
  overflow-x: auto;

  .robot-sort-list {
    width: 100%;
    /* display: flex; */
    /* align-items: center; */
    /* overflow: auto; */

    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-gap: 16rem;
  }
`;

const RobotSortOne: FC<IRobotSortOneProps> = (props) => {
  const { getFaqKnows } = useFaq();
  const userStore = useUserStore();
  const appStore = useAppStore();
  const $t = useLang();

  const knowsResult = useMemo<IRobotMsg>(() => {
    let res = {
      knowledgeBaseTitle: '',
      knowledgeBaseList: [],
    };
    try {
      res = JSON.parse(props.msgBody);
    } catch (error) {}

    return res;
  }, [props.msgBody]);

  return (
    <RobotSortOneWrap>
      <div>{knowsResult.knowledgeBaseTitle}</div>
      <div className="robot-sort-list">
        {knowsResult.knowledgeBaseList.map((item) => (
          <RobotSortOneItem
            knowledgeItem={item}
            key={item.id}
            onClick={() => {
              if (appStore.isKickOff) {
                Message.info($t('chat_session_status_8'));
                return;
              }
              if (userStore.sessionConfig.sessionId !== props.messageItem?.sessionId) {
                Message.info($t('chat_session_status_27'));
                return;
              }
              getFaqKnows(EFaqKnows.question, item.id);
            }}
          />
        ))}
      </div>
    </RobotSortOneWrap>
  );
};

export default RobotSortOne;
